var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0586 22.432C24.2023 22.432 27.5586 19.0758 27.5586 14.932C27.5586 10.7883 24.2023 7.43204 20.0586 7.43204C15.9148 7.43204 12.5586 10.7883 12.5586 14.932C12.5586 19.0758 15.9148 22.432 20.0586 22.432ZM21.9336 37.432L20.3211 35.8195C18.1086 33.607 18.1273 30.007 20.3586 27.832L21.9336 26.2945C21.2023 26.2195 20.6586 26.182 20.0586 26.182C15.0523 26.182 5.05859 28.6945 5.05859 33.682V37.432H21.9336ZM23.2273 33.1008L27.1086 37.0195C27.8398 37.7508 29.0398 37.7508 29.7711 37.0195L39.4086 27.307C40.1211 26.5945 40.1211 25.432 39.4086 24.7008L39.3898 24.682C38.6586 23.9508 37.4773 23.9508 36.7461 24.682L28.4398 33.0445L25.8711 30.4758C25.1586 29.7445 23.9773 29.7445 23.2461 30.4758L23.2273 30.4945C22.5148 31.207 22.5148 32.3695 23.2273 33.1008Z",
    fill: "#652784"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCheck);
export default __webpack_public_path__ + "static/media/UserCheck.fdca97869f86fa889e7a2cec4c3b1aab.svg";
export { ForwardRef as ReactComponent };